class VideoPlayer extends HTMLElement {
  connectedCallback() {
    const videoUrl = this.dataset.video;
    const coverUrl = this.dataset.cover;

    this.innerHTML = `
      <img 
        src="${coverUrl}" 
        alt="Product video" 
        style="width: 100%; display: block;"
      >
      <div class="play-button" style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 70px;
        height: 70px;
        background: rgba(0,0,0,0.6);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      ">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 24 24" width="36" height="36">
          <path d="M8 5v14l11-7z"/>
        </svg>
      </div>
      <iframe 
        style="display: none; width: 100%;"
        data-src="${videoUrl}?autoplay=1"
        title="Product Video"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
    `;

    this._img = this.querySelector('img');
    this._btn = this.querySelector('.play-button');
    this._iframe = this.querySelector('iframe');

    this._onClick = () => {
      this._img.style.display = 'none';
      this._btn.style.display = 'none';
      this._iframe.style.display = 'block';
      this._iframe.src = this._iframe.dataset.src;
    };

    this._btn.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    if (this._btn && this._onClick) {
      this._btn.removeEventListener('click', this._onClick);
    }
  }
}

customElements.define('video-player', VideoPlayer);